export const EVENT_UPDATE_USER = 'updateUser';
